import { Box, Typography, makeStyles } from '@material-ui/core';
import Icon from 'components/Icon/Icon';
import { TTableId } from 'features/home/types/homeTypes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  isDelivery,
  isFoodCourt,
  isPaypalEnabled,
  isPickup,
  isPickupAndDelivery,
  isTableNumber,
  isTableNumberAndRequired,
} from 'submodules/OrderCore';
import { theme } from 'theme';
import useAnalyticsEventTracker from 'utils/analytics/useAnalyticsEventTracker';
import { EEventAction, EEventCategory } from 'utils/constants';
import { PaymentMethodType } from '../containers/AddInformationContainer';
import { useStore } from 'features/home/store/homeSlice';
import { shallow } from 'zustand/shallow';

const useStyles = makeStyles({
  paymentMethodBox: {
    background: theme.palette.grey[400],
    borderRadius: 4,
    padding: '6px 10px 10px',
    marginBottom: 20,
  },
  title: {
    fontWeight: 600,
    lineHeight: '2.4rem',
    color: theme.palette.primary.main,
  },
  payment: {
    color: 'red',
    fontSize: '14px',
  },
  iconBox: {
    flex: 1,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  labelIcon: {
    marginTop: 5,
    fontSize: 12,
    lineHeight: '2.4rem',
    color: theme.palette.text.secondary,
  },
  iconRow: {
    marginTop: 10,
  },
  boxIcon: {
    background: '#939cb0',
    height: 24,
    width: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    margin: 'auto',
  },
});

interface PaymentMethodProps {
  onClick: (type: PaymentMethodType) => void;
  selected: string;
  tableId: TTableId;
}

function PaymentMethod({ onClick, selected, tableId }: PaymentMethodProps) {
  const classes = useStyles();
  const eventTracker = useAnalyticsEventTracker();
  const { t } = useTranslation();
  const { restaurant }: any = useStore(
    (state) => ({
      restaurant: state.homeState.restaurant,
    }),
    shallow,
  );
  const isWechat = selected === PaymentMethodType.WECHAT;
  const isAliPay = selected === PaymentMethodType.ALI_PAY;
  const isBankCard = selected === PaymentMethodType.BANK_CARD;
  const isCash = selected === PaymentMethodType.CASH;
  const isPayPal = selected === PaymentMethodType.PAY_PAL;

  const onSelectPaymentMethod = (type: PaymentMethodType) => {
    eventTracker(EEventCategory.PAYMENT_TYPE_SELECT_EVENT, EEventAction.SELECT, type || '');
    onClick(type);
  };

  const renderPayAtCounter = () => {
    if (isPickupAndDelivery(tableId)) {
      return false;
    } else if (isPickup(tableId)) {
      return false;
    } else if (isDelivery(tableId)) {
      return false;
    } else if (isTableNumber(tableId)) {
      return false;
    } else if (isTableNumberAndRequired(tableId)) {
      return false;
    } else if (isFoodCourt(tableId) && !restaurant.onlineSettings?.foodCourtPaymentOptional) {
      return false;
    }
    return true;
  };

  return (
    <Box className={classes.paymentMethodBox}>
      <Typography className={classes.title}>{t('Payment method')}</Typography>

      <Box display="flex" className={classes.iconRow}>
        {/* {browserName === 'WeChat' && (
          <Box
            onClick={() => onSelectPaymentMethod(PaymentMethodType.WECHAT)}
            className={classes.iconBox}
          >
            <Box
              className={classes.boxIcon}
              style={{ backgroundColor: isWechat ? '#41B035' : theme.palette.text.secondary }}
            >
              <Icon width="17.26" height="17.26" name="wechat" />
            </Box>
            <Typography className={classes.labelIcon}>{t('Wechat')}</Typography>
          </Box>
        )} */}

        {/* <Box
          style={{ color: isAliPay ? '#1296DB' : theme.palette.text.secondary }}
          onClick={() => onSelectPaymentMethod(PaymentMethodType.ALI_PAY)}
          className={classes.iconBox}
        >
          <Icon name="alipay" />
          <Typography className={classes.labelIcon}>{t('Alipay')}</Typography>
        </Box> */}
        {isPaypalEnabled(restaurant) && (
          <Box
            style={{ color: isPayPal ? '#1296DB' : theme.palette.text.secondary }}
            onClick={() => onSelectPaymentMethod(PaymentMethodType.PAY_PAL)}
            className={classes.iconBox}
          >
            <Icon name="paypal" />
            <Typography className={classes.labelIcon}>{t('Pay pal')}</Typography>
          </Box>
        )}
        <Box
          style={{ color: isBankCard ? '#5C89FF' : theme.palette.text.secondary }}
          onClick={() => onSelectPaymentMethod(PaymentMethodType.BANK_CARD)}
          className={classes.iconBox}
        >
          <Icon name="bankcard" />
          <Typography className={classes.labelIcon}>{t('Bank card')}</Typography>
        </Box>
        {renderPayAtCounter() && (
          <Box
            onClick={() => onSelectPaymentMethod(PaymentMethodType.CASH)}
            className={classes.iconBox}
          >
            <Box
              className={classes.boxIcon}
              style={{ backgroundColor: isCash ? '#FFB017' : theme.palette.text.secondary }}
            >
              <Icon width="17.26" height="17.26" name="cash" />
            </Box>
            <Typography className={classes.labelIcon}>{t('Pay at Counter')}</Typography>
          </Box>
        )}
      </Box>
      {selected !== PaymentMethodType.CASH && (
        <Typography className={classes.payment}>
          {t('An additional surcharge will apply')}
        </Typography>
      )}
    </Box>
  );
}

export default PaymentMethod;
